module.exports = __webpack_public_path__ + "static/media/icon_Carrier_Ship_Blue.40d16f1c.svg";